import React, {useEffect} from 'react';
import {ShopifyMap} from "./fragments/shopifyMap";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {
    shopifyInventoryTransferBody,
    shopifyInventoryTransferHead,
} from "./fragments";
import {shopifyActions} from "store";
import {SelectMain} from "../../components";
import {operationTypes, operationTypesEnum, operationTypesFilter} from "../../fragments";
import {useForm} from "react-hook-form";

export const ShopifyInventoryTransfers = () => {

    const {shopifyTransverse} = useSelector((state) => ({
        shopifyTransverse: state.shopify.shopifyTransverse,
    }));
    const {control, watch} = useForm({
        defaultValues: {
            operationType: operationTypesFilter(operationTypesEnum.TRANSFER),
        }
    });
    const operationType = watch('operationType')?.id
    const dispatch = useDispatch();
    const history = useHistory();
    const info = history?.location?.state;


    useEffect(() => {
        const filteredInfo = {
            ...info,
            operationType
        };
        delete filteredInfo.page;
        delete filteredInfo.tab;

        dispatch(shopifyActions.getShopifyTransverse(filteredInfo))
    }, [info, operationType])


    const renderTableValues = {
        head: shopifyInventoryTransferHead(operationType),
        body: shopifyInventoryTransferBody(operationType),
        actionType: 'GET_SHOPIFY_TRANSVERSE',
        list: shopifyTransverse?.inventoryTransfer,
        count: shopifyTransverse?.count,
    }


    return (
        <div>
            <SelectMain
                stylesWrapper={{width: '213px', marginLeft: 'auto'}}
                list={operationTypes}
                renderLabel={(option) => option?.name}
                name='operationType'
                control={control}
                placeholder={'Operation Types'}
                disableClearable
            />
            <ShopifyMap
                // renderParams={renderParams}
                // handleOpen={handleOpenProductMap}
                head={renderTableValues?.head}
                body={renderTableValues?.body}
                operationType={operationType}
                loadingType={renderTableValues?.actionType}
                type={'transfer'}
                list={renderTableValues?.list}
                listCount={renderTableValues?.count}
                // handleSearchReq={handleSearchReq}
            />
        </div>
    );
};

